import React from 'react'
import ErrorContent from './ErrorContent'

/**
 * TODO: 需要支持图片。原因：目前ow-comps引入图片（不会自动转base64的大图）有问题
 * @param {*} param0
 * @returns
 */
export default function ErrorFallback({ error, resetErrorBoundary }) {
  console.error(error)

  return (
    <ErrorContent
      error={error}
      needDetail
      resetErrorBoundary={resetErrorBoundary}
    />
  )
}
